import React, { useState } from 'react';

import classNames from 'classnames';
import CopyIcon from 'icons/copy.svg';
import TickIcon from 'icons/ic-tick.svg';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

export default function PersonalInfo({
  copyable,
  hideIcon,
  isCompact,
  isTruncated,
  label,
  preserveWhitespace,
  text,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const [isCopied, setIsCopied] = useState(false);

  const handleMouseEnter = () => {
    setIsCopied(false);
  };

  return (
    <div
      className={classNames(
        'personal-info',
        isCompact && 'personal-info--compact',
      )}
    >
      <div className='personal-info__info-container'>
        <div className='personal-info__label tw-font-medium tw-text-grey-900'>
          {label}
        </div>
        <div
          className={classNames(
            'personal-info__text',
            !text && 'personal-info__text--not-added tw-text-grey-500',
            isCompact && 'personal-info__text--sm',
            preserveWhitespace && 'personal-info__text--whitespace',
          )}
        >
          <span
            className={classNames(isTruncated && 'truncated-text-container')}
          >
            {text || i18nTShared('notAdded')}
          </span>
        </div>
      </div>
      {text && copyable && (
        <div
          className={classNames(
            'copyable copyable__hit-area tw-group/hit tw-ml-1 tw-mt-5 tw-text-s tw-font-medium tw-tracking-wide',
            hideIcon && 'copyable--hidden',
          )}
          onMouseEnter={handleMouseEnter}
        >
          <div className='copyable__copy-icon-wrapper'>
            <CopyToClipboard onCopy={() => setIsCopied(true)} text={text}>
              <CopyIcon
                className='[&_path]:tw-fill-grey-500 group-hover/hit:[&_path]:tw-fill-blue-500'
                height={20}
                width={20}
              />
            </CopyToClipboard>
          </div>
          <div
            className={classNames(
              'copyable__tooltip copyable__tooltip--right tw-bg-grey-900 tw-text-white',
              isCopied && 'copyable__tooltip--ease-out',
            )}
          >
            {isCopied ?
              <div className='copyable__tooltip-content'>
                <TickIcon className='copyable__tick-icon [&_polygon]:tw-fill-white' />
                <span>{i18nTShared('copiedToClipboard')}</span>
              </div>
            : <span className='copyable__tooltip-content'>
                <span>{i18nTShared('clickToCopyToClipboard')}</span>
              </span>
            }
          </div>
        </div>
      )}
    </div>
  );
}

PersonalInfo.propTypes = {
  copyable: PropTypes.bool,
  isTruncated: PropTypes.bool,
  label: PropTypes.string.isRequired,
  text: PropTypes.node,
};

PersonalInfo.defaultProps = {
  copyable: false,
  isCompact: false,
  isTruncated: true,
};
